export default __webpack_public_path__ + "static/media/time-icon.e9797999.svg";